import axios from "axios";

// If using mocks, baseURL should be empty or '/api' so setupProxy can intercept
// If using real API, use the full backend URL
const getBaseURL = () => {
  const url = process.env.REACT_APP_BACKEND_API_URL;
  
  // If URL is '/api' or starts with '/api/', use empty string (same origin)
  // setupProxy.js will intercept and route to mocks
  if (!url || url === '/api' || url.startsWith('/api/') || url.startsWith('/')) {
    return '';
  }
  
  // Otherwise use the real backend URL (http:// or https://)
  return url;
};

const axiosInstance = axios.create({
    baseURL: getBaseURL()
});

export function setUpInterceptors(auth, logout, tryTokenRefresh) {

    axiosInstance.interceptors.request.use(
        (config) => {
            const access_token = localStorage.getItem("access_token");

            console.log(access_token)

            if (access_token) {
                config.headers.Authorization = `Bearer ${access_token}`;
            }
    
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;

            if (error.response.status === 401 && !originalRequest._retry && !originalRequest.url.includes("token/refresh")) {
                originalRequest._retry = true;

                try {
                    await tryTokenRefresh();

                    const access_token = localStorage.getItem("access_token");
                    originalRequest.headers.Authorization = `Bearer ${access_token}`;

                    return axiosInstance(originalRequest);
                } catch (refreshError) {
                    logout();
                    return Promise.reject(refreshError);
                }
                
            }
    
            return Promise.reject(error);
        }
    );
    
}

export default axiosInstance;
